import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Button} from '@/web-components';

export const UnlinkButton = ({
	onClick,
	messageId = 'common.unlink',
}: {
	onClick: () => void;
	messageId?: string;
}): JSX.Element => {
	return (
		<div style={{marginTop: '8px'}}>
			<Button onClick={onClick} size={Button.SIZE.STANDARD} variant={Button.VARIANT.RED_FILLED}>
				<FormattedMessage id={messageId} />
			</Button>
		</div>
	);
};
